













































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./add.vue";
import Edit from "./edit.vue";

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  dispatchType = "adserver/websites";

  dispatchTypeDelete = "adserver/deleteWebsite";

  deleteConfirmContent = "确认要删除该网站或应用吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "网站或应用名称", scopedSlots: { customRender: "website_name" } },
    { title: "添加时间", dataIndex: "created_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } },
  ];

  mounted() {
    this.loadData();
  }
}
